import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcraiTabLabel]'
})
export class TabLabel {
  @Input() set mcraiTabLabel(value: string) {
    this.color = value
  }

  public color: string;

  constructor(
    public template: TemplateRef<any>
  ) {}
}
